import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {DxNavigationTreeNode} from "../../../../../domain/navigator/dx-navigation-tree-node";

@Component({
  selector: 'dx-head-dropdown-tree',
  templateUrl: './dx-head-dropdown-tree.component.html',
  styleUrls: ['./dx-head-dropdown-tree.component.css']
})
export class DxHeadDropdownTreeComponent implements OnInit, OnDestroy {
  /** Узел первого уровня навигационного меню, являющийся корнем ветки для данного пункта */
  private _menuNode: DxNavigationTreeNode;

  /** @constructor */
  constructor() {}

  ngOnDestroy(): void { }
  ngOnInit(): void { }

  @Input()
  set menuNode(value: DxNavigationTreeNode) {
    this._menuNode = value;
  }
}
